import { getBusinessDayStart } from "../mockUtils";

// Mock data that matches the API response shape (before Zod transformation)
// The API returns Date objects which are then transformed to time strings by the schema
export const mockInsightsDrivers = [
  {
    id: 1,
    driver: "John Doe",
    route: "ANA-1",
    clockInTime: getBusinessDayStart().hour(7).minute(0).toDate(),
    startTime: getBusinessDayStart().hour(8).minute(15).toDate(),
    endTime: getBusinessDayStart().hour(17).minute(30).toDate(),
    breakTime: getBusinessDayStart().hour(12).minute(0).toDate(),
  },
  {
    id: 2,
    driver: "Jane Smith",
    route: "FON-1",
    clockInTime: getBusinessDayStart().hour(6).minute(30).toDate(),
    startTime: getBusinessDayStart().hour(7).minute(45).toDate(),
    endTime: getBusinessDayStart().hour(16).minute(0).toDate(),
    breakTime: getBusinessDayStart().hour(11).minute(30).toDate(),
  },
  {
    id: 3,
    driver: "Mike Johnson",
    route: "FUL-1",
    clockInTime: getBusinessDayStart().hour(8).minute(0).toDate(),
    startTime: getBusinessDayStart().hour(9).minute(0).toDate(),
    endTime: getBusinessDayStart().hour(18).minute(0).toDate(),
    breakTime: getBusinessDayStart().hour(13).minute(0).toDate(),
  },
  {
    id: 4,
    driver: "Sarah Williams",
    route: "PDZ-1",
    clockInTime: getBusinessDayStart().hour(7).minute(30).toDate(),
    startTime: getBusinessDayStart().hour(8).minute(30).toDate(),
    endTime: getBusinessDayStart().hour(17).minute(0).toDate(),
    breakTime: null, // Did not take break
  },
  {
    id: 5,
    driver: "Tom Brown",
    route: "SFO-1",
    clockInTime: getBusinessDayStart().hour(6).minute(0).toDate(),
    startTime: getBusinessDayStart().hour(7).minute(0).toDate(),
    endTime: getBusinessDayStart().hour(15).minute(30).toDate(),
    breakTime: getBusinessDayStart().hour(10).minute(30).toDate(),
  },
  {
    id: 6,
    driver: "Emily Davis",
    route: "ANA-2",
    clockInTime: getBusinessDayStart().hour(8).minute(30).toDate(),
    startTime: getBusinessDayStart().hour(9).minute(30).toDate(),
    endTime: getBusinessDayStart().hour(18).minute(30).toDate(),
    breakTime: getBusinessDayStart().hour(13).minute(30).toDate(),
  },
  {
    id: 7,
    driver: "Robert Wilson",
    route: "FON-2",
    clockInTime: getBusinessDayStart().hour(7).minute(15).toDate(),
    startTime: getBusinessDayStart().hour(8).minute(0).toDate(),
    endTime: getBusinessDayStart().hour(16).minute(45).toDate(),
    breakTime: getBusinessDayStart().hour(12).minute(15).toDate(),
  },
  {
    id: 8,
    driver: "Lisa Anderson",
    route: "FUL-2",
    clockInTime: getBusinessDayStart().hour(6).minute(45).toDate(),
    startTime: getBusinessDayStart().hour(7).minute(30).toDate(),
    endTime: getBusinessDayStart().hour(16).minute(15).toDate(),
    breakTime: null, // Did not take break
  },
];
